import { isNumber } from './string-num-clean.js';

function isNotDefined(v) {
	return typeof v === 'undefined' || v === null;
}

/**
 * [checkAmountLimits amount compared to max- min-
 For a max-value of zero, it follows a convention used on the desktop site
  meaning: 'daily deposit limit is already reached']
 * @param  {[Number]} amount [description]
 * @param  {[Number]} maxLimit    [description]
 * @param  {[Number]} minLimit    [description]
 * @return {[Object of booleans]} [description]
 */
function checkAmountLimits(amount, maxLimit, minLimit) {
	if (isNotDefined(amount)) {
		throw new Error('checkAmountLimits: amount is not defined', amount);
	}
	if (isNotDefined(minLimit)) {
		throw new Error('checkAmountLimits: min limit is not defined', minLimit);
	}
	if (isNotDefined(maxLimit)) {
		throw new Error('checkAmountLimits: max limit is not defined', maxLimit);
	}
	if (!isNumber(amount)) {
		throw new Error('checkAmountLimits only accepts numeric input: amount is not a number', amount);
	}
	if (!isNumber(minLimit)) {
		throw new Error('checkAmountLimits only accepts numeric input: min is not a number', minLimit);
	}
	if (!isNumber(maxLimit)) {
		throw new Error('checkAmountLimits only accepts numeric input: amount is not a number', maxLimit);
	}
	// const am = amount || amount === 0 ? Number(amount) : 0;
	// const maxLimit = max || max === 0 ? Number(max) : 0;
	// const minLimit = min || min === 0 ? Number(min) : 0;
	if (maxLimit === 0 || maxLimit < minLimit) {
		return {
			above: false,
			below: false,
			within: false,
			aboveIsZero: true
		};
	}

	// if (maxLimit <= minLimit) {
	// 	throw new Error(
	// 		`checkAmountLimits: a non-zero maxLimit (has value: ${maxLimit}) must be larger than the minLimit (has value: ${minLimit})`
	// 	);
	// }
	const within = amount >= minLimit && amount <= maxLimit;
	const above = amount > maxLimit;
	const below = amount < minLimit;

	return {
		above,
		below,
		within,
		aboveIsZero: false
	};
}

export default checkAmountLimits;
